import React, { useState, useEffect } from 'react'
import { StyledLabel, StyledValue, StyledWrapperBox } from './styles/style'
import { useSelector, useDispatch } from 'react-redux'
import { getAttachments } from 'states/modules/documentDetail'
import { object } from 'prop-types'
import PdfCarouselModal from '~/components/PdfCarouselModal'

const FileFieldText = ({ data }) => {
	const [isVisible, setIsVisible] = useState(false)
	const [page, setPage] = useState(0)
	const dispatch = useDispatch()
	const { data: attachments } = useSelector(
		({ documentDetail }) => documentDetail.attachments
	)
	const documentId = useSelector(({ documentDetail }) => documentDetail.data.id)

	useEffect(() => {
		dispatch(getAttachments({ id: documentId }))
	}, [documentId, dispatch])

	return (
		<>
			{data.field.label && <StyledLabel>{data.field.label}:</StyledLabel>}
			<StyledWrapperBox>
				{data.value.map((value, index) => (
					<StyledValue key={data.field.label + value.uid}>
						-{' '}
						<button
							style={{
								background: 'none',
								border: 'none',
								color: '#1890ff',
								cursor: 'pointer',
								padding: 0,
							}}
							onClick={() => {
								setPage(index)
								setIsVisible(true)
							}}>
							{value.name}
						</button>
					</StyledValue>
				))}
			</StyledWrapperBox>

			<PdfCarouselModal
				isVisible={isVisible}
				onClose={() => setIsVisible(false)}
				documents={data.value}
				urls={attachments}
				loading={!attachments}
				initialIndex={page}
				title="Anexos"
			/>
		</>
	)
}

FileFieldText.propTypes = {
	data: object,
}

export default FileFieldText
